import { color, Text } from "@smoothincorg/smooth-ui"
import { NextRouter, useRouter } from "next/router"
import React, { useEffect } from "react"
import { A } from "src/components/A"
import { BorderedButton } from "src/components/Button"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import styled from "styled-components"
import {
  AI_EXAM_STATUS_TYPE_KEY,
  AI_EXAM_STATUS_TYPES,
  EXAM_STATUS_TYPE_KEY,
  EXAM_STATUS_TYPES,
  INTRODUCTION_STATUS_TYPE_KEY,
  INTRODUCTION_STATUS_TYPES,
  RelevantQueryParams,
  SEARCH_HOUSE_STATUS_TYPE_KEY,
  SEARCH_HOUSE_STATUS_TYPES,
} from "./ForCIC"

type Props = {
  className?: string
}

const StatusList = (router: NextRouter, statusTypes: Object, statusKey: string) => {
  return (
    <>
      {Object.entries(statusTypes).map(([title, value]) => (
        <li key={value} className={router.query[statusKey] === value ? "selected" : ""}>
          <A
            href={{
              pathname: router.pathname,
              query: {
                ...router.query,
                [statusKey]: value,
                ["load"]: "light",
              },
            }}
          >
            <Text size={16}>{title}</Text>
          </A>
        </li>
      ))}
    </>
  )
}

// eslint-disable-next-line react/display-name
const Component = React.memo<Props>((props) => {
  const router = useRouter()
  const { getWithToken } = useSmoothApi()

  type CountCache = { [key: string]: { total_count: number } }
  const [countCache, setCountCache] = React.useState<CountCache>({})

  useEffect(() => {
    if (!router.isReady) return

    const queryParams: any = {}
    for (const key of RelevantQueryParams) {
      if (router.query[key]) queryParams[key] = router.query[key]
    }
    const queryString = new URLSearchParams(queryParams).toString()
    updateCounter("all", queryString)
  }, [router.query, router.isReady])

  const updateCounter = (cacheKey: string, queryString: string) => {
    const url = `${SMOOTH_SMOOTHER_API_URL}/for_cic/total_count?${queryString}`
    getWithToken(url)
      .then((res) => {
        setCountCache((prev) => {
          return {
            ...prev,
            [cacheKey]: res.data,
          }
        })
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const handleFullLoad = () => {
    // add load=legacy query param and reload the page
    const queryParams: any = {}
    for (const key of RelevantQueryParams) {
      if (router.query[key]) queryParams[key] = router.query[key]
    }
    queryParams["load"] = "legacy"
    const queryString = new URLSearchParams(queryParams).toString()

    window.location.href = `${router.pathname}?${queryString}`
  }

  return (
    <nav
      key={router.asPath}
      className={props.className}
      style={{
        width: "100%",
      }}
    >
      <div>
        <div
          style={{
            marginTop: "5px",
            marginBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Text size={16}>
            検索結果：
            {`${countCache.all?.total_count ?? "-"}`}件
          </Text>
          <BorderedButton
            onClick={handleFullLoad}
            style={{
              backgroundColor: "white",
            }}
          >
            全件詳細読み込み
          </BorderedButton>
        </div>
        <div>
          <h2>審査ステータス</h2>
          <ul>{StatusList(router, EXAM_STATUS_TYPES, EXAM_STATUS_TYPE_KEY)}</ul>
        </div>
        <div>
          <h2>引越し時期</h2>
          <ul>{StatusList(router, SEARCH_HOUSE_STATUS_TYPES, SEARCH_HOUSE_STATUS_TYPE_KEY)}</ul>
        </div>
        <div
          style={{
            display: "flex",
          }}
        >
          <div>
            <h2>自動審査結果</h2>
            <ul>{StatusList(router, AI_EXAM_STATUS_TYPES, AI_EXAM_STATUS_TYPE_KEY)}</ul>
          </div>
          <div
            style={{
              marginLeft: "40px",
            }}
          >
            <h2>店舗利用・集客支援ステータス</h2>
            <ul>{StatusList(router, INTRODUCTION_STATUS_TYPES, INTRODUCTION_STATUS_TYPE_KEY)}</ul>
          </div>
        </div>
      </div>
    </nav>
  )
})

const StyledComponent = styled(Component)`
  h2:not(:first-child) {
    font-weight: bold;
    margin: 20px 0 0;
  }
  .searchBtn {
    width: 10rem;
    border: .5px solid ${color.main};
    border-radius: 5px;
    margin: 0 1rem;
  }
  ul {
    display: flex;
    justify-content: flex-start;

    > li {
      &.selected {
        border-bottom: 2px solid ${color.main};
      }

      > a {
        padding: 8px 10px;
      }
    }
  }
`

export const ForCICNav = StyledComponent
